import Collapse from '@material-ui/core/Collapse/Collapse';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { withStyles } from '@material-ui/styles';
import React, { Component } from 'react';
import adminMenuItems from '../../adminMenu.json';
import styles from '../../assets/jss/sideNavigationStyle';
import menuItems from '../../menu.json';
import ExpendedMenuBar from './ExpendedMenuBar';
import ShortMenuBar from './ShortMenuBar';

class SideNavigationView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showExpendedMenu: true,
    };
    this.currentSelectedMenu = '';
  }

  componentDidMount() {
    // getting the complete current URL
    const { pathname } = window.location;
    if (pathname && pathname.split('/') && pathname.split('/')[1]) {
      const activeLink = pathname.split('/')[1]; // getting the tab
      if (activeLink.includes('user')) {
        this.currentSelectedMenu = 'user';
      } else if (activeLink.includes('client') && !activeLink.includes('cloud')) {
        this.currentSelectedMenu = 'client';
      } else if (activeLink.includes('cloud-client')) {
        this.currentSelectedMenu = 'cloudClient';
      } else if (activeLink.includes('software')) {
        this.currentSelectedMenu = 'software';
      } else if (activeLink.includes('platform')) {
        this.currentSelectedMenu = 'platform';
      } else if (activeLink.includes('system-event')) {
        this.currentSelectedMenu = 'systemEvent';
      } else if (activeLink.includes('syslog-setting')) {
        this.currentSelectedMenu = 'syslogSetting';
      }
    } else {
      this.currentSelectedMenu = 'dashboard';
    }
  }

  /**
   * change menu type , i.e expended mode or min variant
   */
  changeTheme = () => {
    const { showExpendedMenu: currentState } = this.state;

    this.setState(() => ({
      showExpendedMenu: !currentState,
    }));
    const { onChangeMenuType } = this.props;
    onChangeMenuType();
  };

  onMenuSelect = (activeMenu) => {
    if (activeMenu && this.currentSelectedMenu !== activeMenu) {
      this.currentSelectedMenu = activeMenu;
    }
  };

  render() {
    const {
      classes,
      userRoles: roles,
      loginUser,
      clientData,
    } = this.props;

    const { showExpendedMenu } = this.state;
    let menuList = [];

    if (roles && roles.length && loginUser.role.roleName === 'godadmin') {
      menuList = menuItems.data.filter((item) => roles.indexOf(item.module) > -1);
    } else {
      const clientDataResult = clientData;
      let whitelist = null;

      if (clientDataResult.length !== 0 && clientDataResult.data && clientDataResult.data.length !== 0) {
        whitelist = clientDataResult.data[0]?.isWhitelistIP;
      }

      if (whitelist !== null && !whitelist) {
        adminMenuItems.data = adminMenuItems.data.filter((item) => item.module !== 'whiteListedIp');
      }

      if (roles && roles.length && loginUser.role.roleName === 'sales') {
        menuList = menuItems.data.filter((item) => roles.indexOf(item.module) > -1);
      } else if (roles && roles.length && loginUser.role.roleName === 'developer') {
        menuList = adminMenuItems.data.filter((item) => roles.indexOf(item.module) > -1 && item.role === loginUser.role.roleName);
      } else {
        menuList = adminMenuItems.data.filter((item) => roles.indexOf(item.module) > -1 && !item.role);
      }
    }
    return (
      <>
        <div className={`${classes.sidebar} ${showExpendedMenu ? ' ' : 'sidebarClosed'}`}>
          <Collapse in={showExpendedMenu} timeout="auto" unmountOnExit>
            <ExpendedMenuBar
              menuList={roles}
              menuItems={menuList}
              defaultSelectedMenu={this.currentSelectedMenu}
              onMenuSelect={this.onMenuSelect}
            />
          </Collapse>
          <Collapse in={!showExpendedMenu} timeout="auto" unmountOnExit>
            <ShortMenuBar
              menuList={roles}
              menuItems={menuList}
              defaultSelectedMenu={this.currentSelectedMenu}
              onMenuSelect={this.onMenuSelect}
            />
          </Collapse>

          <div className={classes.expendMenu} onClick={this.changeTheme} aria-hidden="true">
            <ArrowBackIcon />
          </div>

        </div>
        <div className={classes.mobileExpendMenu} onClick={this.changeTheme} aria-hidden="true">
          <span className={classes.sideMenuIcon} />
        </div>
      </>
    );
  }
}

export default withStyles(styles, { withTheme: true })(SideNavigationView);
